import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import User from './icon-user.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <User {...validProps} />;
}

SvgComponent.iconName = 'user';

/**
 * @deprecated This is a legacy icon
 */
export const UserIcon = svgIconWrapper(SvgComponent);
